import { IRootState } from '../../../../store'
import { IRescueState } from '../store/rescue.types'

export const getRescueSelector = (state: IRootState): IRescueState => state.rescue
